<template>
  <div class='report'>
    <div class="bg">
      <div class="input-line-box">
        <div class="line"></div>
        <div class="input-left">Trial Name</div>
        <div class="input-right">
          {{ trialName }}
        </div>
      </div>
      <div class="input-line-box">
        <div class="line"></div>
        <div class="input-left">Column Name</div>
        <div class="input-right">
          {{ columnName }}
        </div>
      </div>
      <div class="input-line-box">
        <div class="line"></div>
        <div class="input-left">From URL</div>
        <div class="input-right">
          <a :href="trialUrl" target="_blank">{{ trialUrl }}</a>
        </div>
      </div>
      <div class="report-title">Report</div>
      <div class="btn-box" v-show="reportList?.length >= 2">
        <el-tooltip 
          class="box-item"
          effect="light"
          placement="top"
          v-for="filePath in reportList" :key="filePath"
          :content="lastFileName(filePath)">
          <el-button class="btn"  :style="{color: btnColor(filePath)}"  @click="showReport(filePath)">{{ lastFileName(filePath) }}</el-button>
        </el-tooltip>
      </div>
      <div class="report-content-bg" v-loading="loading">
        <pre class="report-content">{{ contentStr }}</pre>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, getCurrentInstance, computed } from 'vue'
import { useRoute } from 'vue-router';
import {
  getNewOSSUrl,
  getQueryStatus
} from "@/request/api";
import {
  ResourceType,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import {
  getUrlData
} from "@/request/axiosApi";
import { getPreReportContent, setPreReportContent, clearPreReportContent } from '@/utils/Setitem'
import { resolveTarFile } from '@/utils/tar-util'
import { ElMessage } from 'element-plus';
const route = useRoute()
const { proxy } = getCurrentInstance()

const trialName = route.params.trialName
const columnName = route.params.columnName
const trialId = route.params.trialId
document.title = `${trialName} ${columnName}`
const origin = window.location.origin;
const trialUrl = origin + '/benchmark/trial/' + trialId
const reportList = proxy.$DataString.tarReports[`${columnName}`]
const storeKey = trialName + "_" + columnName

let contentStr = ref('')
let loading = ref(false)
let trialOutList = []
const reportsDataList = []
let selectReportPath = ''

const lastFileName = computed(()=>(reportPath) => {
  if (!reportPath || !reportPath.includes(":")) {
    return ""
  }
  const arr = reportPath.split(":")
  //const tarPath = arr[0]
  //const fileName = tarPath.split("/").pop()
  const fileName = arr[1]
  return fileName
})

const btnColor = computed(()=>(reportPath) => {
  return selectReportPath ==  reportPath ? '#0052d9' : '#333'
})

created()

async function created() {
   await getTrialInfo()
  if (reportList?.length > 0) {
    const normalPath = reportList[0]
    selectReportPath = normalPath
    getTarFileContent(normalPath)
  }
}

async function getTrialInfo() {
  const trialData = await getQueryStatus(trialId, ResourceType.TRIAL);
  trialOutList = trialData.run?.outputsList
}

function showReport(filePath) {
  getTarFileContent(filePath)
}

async function getTarFileContent(showReportPath) {
  // clearPreReportContent()
  const reportPath = showReportPath
  selectReportPath = reportPath
  if (!reportPath) {
    return
  }
  const arr = reportPath.split(":")
  const tarPath = arr[0]
  const fileName = tarPath.split("/").pop()
  const filePath = arr[1]

  const reportModel = getPreReportContent()
  let storeReportList = []
  let reportContent = ''
  if (reportModel) {
    storeReportList = reportModel[`${storeKey}`]
    const reportM  = storeReportList?.find(r => {
      return r[`${filePath}`] 
    }) 
    if (reportM) {
      reportContent = reportM[`${filePath}`]
    }
  }
 
  if (reportContent) {
    contentStr.value = reportContent
  } else {
      const ossKey = `${trialId}/${tarPath}`
      const trialItem = trialOutList?.find(model => {
        return model.ossfile?.key == ossKey
      })
      if (!trialItem) {
        ElMessage.warning("the file was not found !")
        return
      }
      const bucketName = trialItem?.ossfile?.bucket ? trialItem.ossfile?.bucket : "icb-rbf-run"
      const url = await getNewOSSUrl(
        bucketName,
        ossKey,
        fileName
      );
      loading.value = true
      const urlData = await getUrlData(url, false)
      const cont = await resolveTarFile(urlData, filePath)
      loading.value = false
      contentStr.value = cont

      clearPreReportContent()
      const m = {}
      m[`${filePath}`] = cont
      storeReportList.push(m)
      reportsDataList.push(m)
      const model = {}
      model[`${storeKey}`] = storeReportList
      setPreReportContent(model)
  }
}

</script>
<style lang='less' scoped>
.report {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 0px 10px;
}

.bg {
  margin: 10px auto;
  min-width: 1200px;
  width: calc(100% - 850px);
  max-width: 2000px;
  margin-top: 10px;
}

@media screen and (max-width: 1500px) {
  .bg {
    margin: 10px auto;
    width: calc(100% - 380px);
    min-width: 549px; //700px;
  }
}

.trial-content-box {
  display: flex;
  flex-direction: row;
  background-color: #fff;
}

.input-line-box {
  display: flex;
  background-color: #fff;
  padding: 10px 30px 10px 0px;
  align-items: center;

  .line {
    width: 5px;
    height: 35px;
    background-color: #fbad15;
  }

  .input-left {
    margin-left: 30px;
    display: flex;
    width: 180px;
    background-color: #ecf2fe;
    height: 35px;
    align-items: center;
    padding-left: 10px;
    color: #383838;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .input-right {
    background-color: #f5f5f5;
    height: 35px;
    display: flex;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
    min-width: 300px;
    width: calc(100% - 280px);
    margin-left: 50px;
    margin-right: 30px;
    padding: 0px 10px;
    overflow: hidden;
    color: #565656;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;

    a {
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;
      color: #0052d9;
    }
  }
}

.report-title {
  margin-top: 15px;
  height: 35px;
  width: 100%;
  background-color: #fff;
  color: #0052d9;
  line-height: 35px;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 500;
}

.btn-box {
  margin-top: 10px;
  .btn {
    max-width: 150px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding: 0px 4px;
  }
}

.report-content-bg {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  min-height: 60px;
  background-color: #fff;

  .report-content {
    width: 100%;
    font-size: 14px;
    text-align: left;
    white-space: pre-wrap;
    word-wrap:break-word;
  }
}
</style>